<template>
    <div class='export-info-bar'>
        <span class='ellipsis-text export-info-text'>
            {{testText}}
        </span>
        <span class='expand-button export-btn-group'>
          展开
        </span>
    </div>
</template>

<script>
export default {
    name: 'testMore',
    props: {
        testText: {
            type: String,
            default: '',
        },
    },
    data() {
        return {
            isHide: false, // 以后做是否显示提示语
            isShowMore: false, // 默认不显示'更多'
        };
    },
    mounted() {
        this.init();
    },
    methods: {
        init() {
            // 获取文本容器
            const textContents = document.querySelectorAll('.export-info-text');
            // 获取按钮容器
            const expandButtons = document.querySelectorAll('.expand-button');
            // 检查文本是否有超出两行的文本，并显示展开按钮
            textContents.forEach((content, index) => {
                // 输出查看当前高度是否超过两行高度（根据当前字体大小进行适配）
                if (content.scrollHeight > content.clientHeight) {
                    expandButtons[index].style.display = 'block'; // 显示展开按钮
                    this.addContentBefore(expandButtons[index], '...'); // 按钮前方模拟省略号
                }
            });

            // 为所有按钮绑定点击事件
            expandButtons.forEach((button, index) => {
                button.addEventListener('click', () => {
                    // 切换文本的max-height属性，实现展开效果
                    const content = textContents[index];
                    if (content.style.maxHeight !== 'none') {
                        // 如果未展开，展开所有文本
                        content.style.maxHeight = 'none';
                        button.textContent = '收起'; // 改变按钮文本
                        this.addContentBefore(button, '');
                    } else {
                        // 如果已经展开，恢复
                        content.style.maxHeight = '72px'; // 恢复到两行的高度
                        button.textContent = '展开'; // 恢复按钮文本
                        this.addContentBefore(button, '...');
                    }
                });
            });
        },
        addContentBefore(element, content){
            // 创建一个新的伪元素
            const pseudoElement = document.createElement('span');
            pseudoElement.classList.add('pseudo-element');
            pseudoElement.textContent = content;

            // 将伪元素插入到目标元素的前面
            if (element.firstChild) {
                element.insertBefore(pseudoElement, element.firstChild);
            } else {
                element.appendChild(pseudoElement);
            }
        }
    },
    watch: {
        testText() {
            this.init();
        },
    },
};
</script>

<style scoped>
/* 底部容器 */
.export-info-bar {
    position: relative;
    //margin-top: 10px;
}

/* 文本 */
.ellipsis-text {
    position: relative;
    /* float: left; */
    /* （***）设置最大高度为两行的高度 */
    max-height: 72px;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    overflow: hidden;
    word-break: break-all;
    word-wrap: break-word;
    /* 设置文本在按钮下方 */
    z-index: 0;
}

/* 按钮前方省略号的样式 */
.pseudo-element {
    color: #000;
    margin-right: 5px;
}

/* 按钮 */
.expand-button {
    /* (***) 设置定位，使按钮与最后一行平行并覆盖在最后一行上方 */
    position: absolute;
    /* 设置按钮浮动在右方 */
    /* float: right; */
    /* 默认隐藏按钮 */
    display: none;
    /* 将按钮向上移动一行 */
    right: 0;
    bottom: -2px;
    color: #ff7f2e;
    /* 此处背景一定要设置， */
    background: #fff;
}
</style>
